export const getDrawerManager = (maps: any) =>
  new maps.drawing.DrawingManager({
    drawingControl: false,
    drawingControlOptions: {
      position: maps.ControlPosition.TOP_CENTER,
      drawingModes: [
        maps.drawing.OverlayType.CIRCLE,
        maps.drawing.OverlayType.POLYGON,
        maps.drawing.OverlayType.POLYLINE,
        maps.drawing.OverlayType.RECTANGLE,
      ],
    },
    markerOptions: {
      icon:
        "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
    },
    circleOptions: {
      fillColor: "#ffff00",
      fillOpacity: 1,
      strokeWeight: 5,
      clickable: false,
      editable: true,
      zIndex: 1,
    },
    polygonOptions: {
      fillColor: "#1E90FF",
      strokeColor: "#1E90FF",
      clickable: true,
      editable: true,
    },
    polylineOptions: {
      strokeColor: "#1E90FF",
      clickable: true,
      editable: true,
    },
  });
